import XhrPromise from "./XhrPromise";
const setHeaders = (req, headers) => {
  if (headers) {
    Object.keys(headers).forEach(name => {
      if (headers[name] !== undefined) {
        req.setRequestHeader(name, headers[name]);
      }
    });
  }
};
const request = function (url, data) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const req = new XMLHttpRequest();
  return new XhrPromise((resolve, reject) => {
    var _options$preSend;
    req.onerror = () => reject(req);
    req.ontimeout = () => reject(req);
    req.onabort = () => reject(req);
    req.onload = () => resolve(req);
    req.open((options === null || options === void 0 ? void 0 : options.method) || "GET", url);
    setHeaders(req, options === null || options === void 0 ? void 0 : options.headers);
    req.withCredentials = !!(options !== null && options !== void 0 && options.withCredentials);
    options === null || options === void 0 ? void 0 : (_options$preSend = options.preSend) === null || _options$preSend === void 0 ? void 0 : _options$preSend.call(options, req);
    req.send(data);
  }, req);
};
export default request;